import { useAppSelector } from '@user/store/hooks'
import { selectKnockStatusFilterEnabled } from '@user/store/tenantFeatures'

export function useKnockStatusFilterEnabled() {
  return useAppSelector(selectKnockStatusFilterEnabled)
}
